<c-container class="mt-5">
  <h2>Manage Charities</h2>

  @if (isCrossGame) {
    <app-choose-your-game [message]="'Choose a game to view and manage its charities'"
                          (gameChosenEvent)="onGameChosen($event)"></app-choose-your-game>
  }

  @if (game) {
    <c-row *hasPermission="PermissionTypes.ModifyCharities">
      <c-col class="text-end">
        <button mat-raised-button
                color="primary"

                data-testid="add-charities-button"
                (click)="addNewCharities()">
          <mat-icon class="enable-sort">add</mat-icon>
          Add Charities
        </button>
      </c-col>
    </c-row>
    <c-row class="mb-3">
      <c-col md="3" class="mb-3">
        <div cListGroup>
          <button cListGroupItem
                  data-testid="general-info-tab"
                  (click)="currentScreenState = charityManagementScreenState.SortAndView"
                  [active]="currentScreenState === charityManagementScreenState.SortAndView">
            <div>
              <h5 class="mb-1">View Charities</h5>
              <p>view all charity categories and their charities</p>
            </div>
          </button>

          <button cListGroupItem
                  data-testid="player-numbers-tab"
                  *hasPermission="PermissionTypes.MovePlayersToAnotherCharity"
                  (click)="currentScreenState = charityManagementScreenState.MoveCharityPledgesBetweenCharities"
                  [active]="currentScreenState === charityManagementScreenState.MoveCharityPledgesBetweenCharities">
            <div>
              <h5 class="mb-1">Move Charity Pledges Between Charities</h5>
              <p>looking to move players and their pledges from one charity to another?</p>
            </div>
          </button>

        </div>
      </c-col>

      <c-col>
        @switch (currentScreenState) {
          @case (charityManagementScreenState.SortAndView) {
            <app-manage-charities [gameSetter]="game"></app-manage-charities>
          }
          @case (charityManagementScreenState.MoveCharityPledgesBetweenCharities) {
            <app-move-players-pledges-between-charities
              [gameSetter]="{ gameP: game, isCrossGame: true }"></app-move-players-pledges-between-charities>
          }
        }
      </c-col>
    </c-row>

  }

</c-container>
